export const DE_DE_KICORE = {
 "catalog": {
 "6 meses": "6 Monate",
 "1 año": "1 Jahr",
 "Próximos 12 meses": "Nächste 12 Monate",
 "El correo electrónico no es válido": "Die E-Mail-Adresse ist ungültig",
 "la versión": "die Version",
 "publicada": "veröffentlicht",
 "Escribe la versión para confirmar": "Version zur Bestätigung eingeben",
 "Es la versión en distribución: al borrarla se retira también el puntero del canal y los equipos dejarán de recibir actualizaciones desde aquí.": "Es ist die Version im Umlauf: Beim Löschen wird auch der Kanalzeiger entfernt, und Geräte erhalten von hier keine Updates mehr.",
 "Se eliminará el paquete y su manifest. Los equipos que ya la tengan instalada no se ven afectados.": "Das Paket und sein Manifest werden gelöscht. Geräte, auf denen es bereits installiert ist, sind nicht betroffen.",
 "Destino": "Zielgruppe",
 "Sin declarar": "Nicht angegeben",
 "Destino de la versión": "Zielgruppe der Version",
 "Se publicó antes de declarar destino: se trata como dirigida a equipos": "Vor Einführung der Zielgruppen veröffentlicht: wird als für Geräte bestimmt behandelt",
 "Esta versión se publicó sin declarar destino, así que se trata como dirigida a equipos": "Diese Version wurde ohne Zielgruppe veröffentlicht und wird daher als für Geräte bestimmt behandelt",
 "Es la versión en distribución, así que el cambio tiene efecto de inmediato": "Es ist die Version im Umlauf, die Änderung wirkt daher sofort",
 "No está en distribución: el cambio tendrá efecto cuando se publique": "Nicht im Umlauf: Die Änderung wirkt, sobald sie veröffentlicht wird",
 "¿A qué va dirigido este software?": "Für wen ist diese Software bestimmt?",
 "Equipos": "Geräte",
 "Aplicaciones de usuario": "Benutzeranwendungen",
 "Aplicación de usuario": "Benutzeranwendung",
 "Core comprueba que el equipo esté registrado y con la suscripción en regla": "Core prüft, ob das Gerät registriert ist und sein Abonnement in Ordnung ist",
 "Se descarga sin comprobar nada en Core, porque no hay equipo que comprobar": "Wird ohne Prüfung in Core heruntergeladen, da es kein Gerät zu prüfen gibt",
 "Destino del software": "Zielgruppe der Software",
 "Cambiar destino": "Zielgruppe ändern",
 "Destino actualizado": "Zielgruppe aktualisiert",
 "Consultando el destino actual": "Aktuelle Zielgruppe wird abgefragt",
 "Dejará de comprobarse la suscripción": "Das Abonnement wird nicht mehr geprüft",
 "Cualquiera con un token válido podrá descargar este software, sin pasar por Core.": "Jede Person mit einem gültigen Token kann diese Software herunterladen, ohne über Core zu gehen.",
 "El cambio se aplica a todas las versiones publicadas de este firmware": "Die Änderung gilt für alle veröffentlichten Versionen dieser Firmware",
 "Gestión de versiones de firmware OTA": "Verwaltung der OTA-Firmware-Versionen",
 "el firmware": "die Firmware",
 "el canal": "den Kanal",
 "la variante": "die Variante",
 "la carpeta": "den Ordner",
 "Eliminar definitivamente": "Endgültig löschen",
 "Esta acción no se puede deshacer": "Diese Aktion kann nicht rückgängig gemacht werden",
 "Se eliminarán todas las versiones que cuelgan de esta ruta, incluidas las que estén en distribución. Los equipos dejarán de recibir actualizaciones desde aquí.": "Alle Versionen unter diesem Pfad werden gelöscht, auch die im Umlauf befindlichen. Geräte erhalten von hier keine Updates mehr.",
 "Se eliminará": "Wird gelöscht",
 "Calculando lo que contiene": "Inhalt wird ermittelt",
 "Escribe la ruta para confirmar": "Pfad zur Bestätigung eingeben",
 "Nuevo firmware": "Neue Firmware",
 "Nuevo canal": "Neuer Kanal",
 "Nueva variante": "Neue Variante",
 "Nueva versión": "Neue Version",
 "Sin versiones publicadas": "Keine veröffentlichten Versionen",
 "Se creará el firmware": "Die Firmware wird angelegt",
 "Se creará el canal": "Der Kanal wird angelegt",
 "Se creará la variante": "Die Variante wird angelegt",
 "Las carpetas del almacén nacen con su primera versión": "Ordner im Speicher entstehen mit ihrer ersten Version",
 "Publicar una versión": "Version veröffentlichen",
 "Publicar": "Veröffentlichen",
 "Nuevo o existente": "Neu oder vorhanden",
 "Sin variante": "Ohne Variante",
 "Se publicará en": "Wird veröffentlicht unter",
 "Esa versión ya existe en este destino": "Diese Version existiert an diesem Ziel bereits",
 "Solo se admiten letras, números, punto, guion y guion bajo": "Erlaubt sind nur Buchstaben, Zahlen, Punkt, Bindestrich und Unterstrich",
 "Al publicarla, los equipos del canal empezarán a descargarla": "Nach der Veröffentlichung laden die Geräte des Kanals sie herunter",
 "Subiendo el paquete": "Paket wird hochgeladen",
 "Procesando en el servidor: checksum y manifest": "Verarbeitung auf dem Server: Checksumme und Manifest",
 "Quitar": "Entfernen",
 "Buscar versión": "Version suchen",
 "Ver como tabla": "Als Tabelle anzeigen",
 "Ver como tarjetas": "Als Karten anzeigen",
 "Ninguna versión coincide con la búsqueda": "Keine Version entspricht der Suche",
 "Subir un nivel": "Eine Ebene nach oben",
 "Todos los firmwares": "Gesamte Firmware",
 "Variante": "Variante",
 "canal": "Kanal",
 "canales": "Kanäle",
 "variante": "Variante",
 "variantes": "Varianten",
 "O pulsa para elegirlo": "Oder klicken, um sie auszuwählen",
 "versión": "Version",
 "carpeta": "Ordner",
 "Selecciona un firmware o un canal para ver su contenido": "Wählen Sie eine Firmware oder einen Kanal, um den Inhalt zu sehen",
 "Carpetas": "Ordner",
 "Versiones": "Versionen",
 "versiones": "Versionen",
 "carpetas": "Ordner",
 "Selecciona un canal para ver su contenido": "Wählen Sie einen Kanal, um seinen Inhalt zu sehen",
 "Esta carpeta solo contiene otras carpetas": "Dieser Ordner enthält nur weitere Ordner",
 "Firmwares": "Firmware",
 "Firmware": "Firmware",
 "En distribución": "Im Umlauf",
 "Poner en distribución": "In Umlauf bringen",
 "Ninguna versión en distribución": "Keine Version im Umlauf",
 "Eliminar y retirar de distribución": "Löschen und aus dem Umlauf nehmen",
 "Descargar": "Herunterladen",
 "Publicada": "Veröffentlicht",
 "Actualizar": "Aktualisieren",
 "Sin firmwares publicados": "Noch keine Firmware veröffentlicht",
 "Selecciona un canal para ver sus versiones": "Wählen Sie einen Kanal, um seine Versionen zu sehen",
 "Arrastra aquí el paquete de firmware": "Firmware-Paket hier ablegen",
 "O pulsa para elegirlo y completar los datos de la versión": "Oder klicken, um es auszuwählen und die Versionsdaten auszufüllen",
 "Un firmware o un canal nuevo nace al subir su primera versión": "Eine neue Firmware oder ein neuer Kanal entsteht beim Hochladen der ersten Version",
 "Variante (opcional)": "Variante (optional)",
 "Distingue compilaciones del mismo canal, por ejemplo rpi4": "Unterscheidet Builds desselben Kanals, zum Beispiel rpi4",
 "Versiones de firmware": "Firmware-Versionen",
 "Firmware OTA": "OTA-Firmware",
 "Carpeta": "Ordner",
 "Publicada por": "Veröffentlicht von",
 "Archivo": "Datei",
 "Tamaño": "Größe",
 "Acciones": "Aktionen",
 "Marcar latest": "Als latest markieren",
 "¿Marcar esta versión como latest?": "Diese Version als latest markieren?",
 "Los dispositivos del canal se actualizarán a esta versión": "Die Geräte des Kanals werden auf diese Version aktualisiert",
 "¿Borrar la versión latest?": "Die latest-Version löschen?",
 "Es la versión latest del canal: se borrará también el puntero": "Es ist die latest-Version des Kanals: Der Zeiger wird ebenfalls gelöscht",
 "Productos": "Produkte",
 "Subir versión": "Version hochladen",
 "Versión marcada como latest": "Version als latest markiert",
 "Versión borrada correctamente": "Version erfolgreich gelöscht",
 "Las carpetas se crean al subir su primera versión": "Ordner werden beim Hochladen ihrer ersten Version angelegt",
 "Producto": "Produkt",
 "Canal": "Kanal",
 "Target (opcional)": "Target (optional)",
 "Subcarpeta para diferenciar builds, por ejemplo rpi4": "Unterordner zur Unterscheidung von Builds, zum Beispiel rpi4",
 "Campo obligatorio": "Pflichtfeld",
 "Seleccionar archivo": "Datei auswählen",
 "Marcar como latest": "Als latest markieren",
 "Formato no permitido": "Format nicht zulässig",
 "Selecciona el archivo de firmware": "Wählen Sie die Firmware-Datei aus",
 "Versión subida correctamente": "Version erfolgreich hochgeladen",
 "Subir": "Hochladen",
 "Caducidad suscripci\u00f3n": "Abonnement-Verfallsdatum",
 "Cambiar tarifa": "Tarif \u00e4ndern",
 "Selecciona la tarifa destino para las tarjetas seleccionadas": "W\u00e4hlen Sie den Zieltarif f\u00fcr die ausgew\u00e4hlten Karten", 
 "Selecciona tarjetas y una tarifa": "W\u00e4hlen Sie Karten und einen Tarif", 
 "Algunas tarjetas no se pudieron actualizar": "Einige Karten konnten nicht aktualisiert werden", 
 "Actualizadas": "Aktualisiert", 
 "Fallidas": "Fehlgeschlagen", 
"Error 404": "Fehler 404", 
 "Detalles Administrativos": "Verwaltungsdetails", 
 "Detalles  M2M": "Details zu M2M", 
 "Search": "Suche", 
 "Reset": "Zur\u00fccksetzen", 
 "Instalaci\u00f3n/Pedido": "Ger\u00e4t/Bestellung", 
 "Cliente": "Klient", 
 "Estado": "Status", 
 "Desactivada": "Behindert", 
 "Activada": "Aktiviert", 
 "Inactiva nueva": "Inaktiv neu", 
 "Lista para activaci\u00f3n": "Bereit zur Aktivierung", 
 "Desconocido": "Unbekannt", 
 "Consumo diario": "T\u00e4glicher Verbrauch", 
 "Consumo mensual": "Monatlicher Verbrauch", 
 "Comienzo \u00faltima conexi\u00f3n": "Start der letzten Verbindung", 
 "Fin \u00faltima conexi\u00f3n": "Ende der letzten Verbindung", 
 "Compa\u00f1\u00eda de red": "Netzwerkunternehmen", 
 "C\u00f3digo de pa\u00eds": "Landesvorwahl", 
 "Tipo de red": "Netzwerkart", 
 "Tipo de tarifa": "Geb\u00fchrenart", 
 "Zona 1": "Zone 1", 
 "Sin asignar": "Nicht zugeordnet", 
 "Cambiar ciclo vida": "Lebenszyklus \u00e4ndern", 
 "Por favor, seleccione una opci\u00f3n": "Bitte w\u00e4hle eine Option", 
 "Desactivar": "Deaktivieren", 
 "Activar": "Aktivieren Sie", 
 "Test": "Pr\u00fcfen", 
 "Estado GSM": "GSM-Status", 
 "Estado GPRS": "GPRS-Status", 
 "Buscar": "Suche", 
 "Borrar": "L\u00f6schen", 
 "Nombre": "Name", 
 "Descripci\u00f3n": "Beschreibung", 
 "UUID placa": "UUID Platte", 
 "Estado instalaci\u00f3n": "Ger\u00e4testatus", 
 "Desconectada": "Getrennt", 
 "Conectada": "Verbunden", 
 "Deshabilitada": "Behindert", 
 "Habilitada": "Erm\u00f6glicht", 
 "Detalles": "Einzelheiten", 
 "No se pudieron actualizar los datos": "Daten konnten nicht aktualisiert werden", 
 "Pools actualizados correctamente": "Pools erfolgreich aktualisiert", 
 "Tarjetas activas / tarjetas totales": "Aktive Karten / Karten insgesamt", 
 "Consumo del pool / Pool total": "Poolverbrauch / Gesamtpool", 
 "Gasto estimado del pool": "Gesch\u00e4tzte Poolkosten", 
 "\u00daltima actualizaci\u00f3n": "Letztes Update", 
 "Refrescar": "Aktualisierung", 
 "Actualizar token de acceso": "Zugriffstoken aktualisieren", 
 "Por favor, complete este campo": "Bitte f\u00fcllen Sie dieses Feld aus", 
 "Enviar": "Schicken", 
 "Placa creada correctamente": "Board erfolgreich erstellt", 
 "Placa actualizada correctamente": "Board erfolgreich aktualisiert", 
 "MAC err\u00f3nea": "Falscher MAC", 
 "SSID err\u00f3neo": "Falsche SSID", 
 "Nuevo kiwi": "Neue Kiwi", 
 "Informaci\u00f3n de kiwi": "Kiwi-Informationen", 
 "Guardar": "Speichern", 
 "UUID err\u00f3neo": "Falsche UUID", 
 "Nuevo kibox": "Neue Kibox", 
 "Informaci\u00f3n de kibox con UUID": "Kibox-Informationen mit UUID", 
 "Informaci\u00f3n de kibox": "Kibox-Informationen", 
 "Habr\u00e1 mas de una placa con ese uuid.\u00bfEst\u00e1 seguro de esto?": "Es wird mehr als eine board mit diesem Uuid geben. Bist du dir dessen sicher?", 
 "Modelo placa": "Board-Modell", 
 "Seleccionar opci\u00f3n": "W\u00e4hle eine Option", 
 "Tarda demasiado en encenderse": "Das Einschalten dauert zu lange", 
 "Usuario": "Benutzer", 
 "Nombre de usuario": "Nutzername", 
 "Rol": "Rolle", 
 "Organizaci\u00f3n": "Organisation", 
 "Apellidos": "Nachname", 
 "Email": "Email", 
 "Complete los campos obligatorios": "F\u00fcllen Sie die erforderlichen Felder aus", 
 "Las contrase\u00f1as tienen que ser iguales": "Passw\u00f6rter m\u00fcssen gleich sein", 
 "Nombre de Usuario": "Nutzername", 
 "Correo electr\u00f3nico": "Email", 
 "Contrase\u00f1a": "Passwort", 
 "Repetir contrase\u00f1a": "Passwort wiederholen", 
 "Selecciona organizaci\u00f3n": "Organisation ausw\u00e4hlen", 
 "Nivel": "Stufe", 
 "Selecciona un rol": "W\u00e4hlen Sie eine Rolle aus", 
 "Superadministrador": "H\u00f6chster Vorgesetzter", 
 "Administrador": "Administrator", 
 "Operador": "Operator", 
 "Visitante": "Besucher", 
 "Activo": "Aktiv", 
 "Crear cuenta": "Benutzerkonto anlegen", 
 "Inicio": "Start", 
 "Nuevo equipo": "Neues Ger\u00e4t", 
 "Stock": "Aktie", 
 "Asignaciones": "Zuordnungen", 
 "Lista equipos": "Ger\u00e4teliste", 
 "Instalaciones": "Ger\u00e4te", 
 "Listado M2M": "M2M Auff\u00fchren", 
 "Listado Pools": "Pools Auff\u00fchren", 
 "Soporte": "Mittel", 
 "Crear Usuario": "Benutzer erstellen", 
 "Lista Usuarios": "Benutzer auflisten", 
 "error": "Fehler", 
 "Informaci\u00f3n de tarjeta M2M con icc": "Informationen der M2M-Karte mit icc", 
 "Alias": "Alias", 
 "Life Cycle Status": "Lebenszyklusstatus", 
 "Pais": "Land", 
 "Plan": "Planen", 
 "Estado Actual": "Aktueller Status", 
 "\u00daltimo evento": "Letzte Veranstaltung", 
 "Tecno.Conexi\u00f3n": "Verbindungstechnik", 
 "\u00daltima Conexi\u00f3n": "Letzte Verbindung", 
 "Complete los campos": "F\u00fcllen Sie die Felder aus", 
 "Inicio de sesi\u00f3n exitoso": "Anmeldung erfolgreich", 
 "Introduzca un nombre de usuario": "Gebe einen Benutzernamen ein", 
 "Introduzca una contrase\u00f1a": "Geben Sie ein Passwort ein", 
 "Iniciar sesi\u00f3n": "Anmeldung", 
 "Eliminar": "L\u00f6schen", 
 "Editar": "Bearbeiten", 
 "Asignar": "Zuordnen", 
 "N\u00famero de serie err\u00f3neo": "Falsche Seriennummer", 
 "Nuevo KiWi": "Neue Kiwi", 
 "Pedido": "Befehl", 
 "N serie": "Seriennummer", 
 "Fecha fabricaci\u00f3n": "Herstellungsdatum", 
 "Estado de fabricaci\u00f3n": "Fertigungsstatus", 
 "KiWi terminado": "Kiwi ist fertig", 
 "No se ha podido terminar": "Konnte nicht beenden", 
 "Terminar": "Beenden", 
 "Version hardware": "Hardware Version", 
 "Modelo": "Modell", 
 "Tipo USB": "USB-Typ", 
 "Instalaci\u00f3n": "Ger\u00e4t", 
 "Cliente kiconex": "Kiconex-Kunde", 
 "Cliente final": "Endkunde", 
 "N\u00famero de serie": "Seriennummer", 
 "kiconex plan": "Kiconex planen", 
 "Nº dispositivos": "Anzahl der Ger\u00e4te", 
 "Cuadro": "Rahmen", 
 "Placa terminada": "Fertiges Brett", 
 "Opcionales": "Optionen", 
 "Notas": "Anmerkungen", 
 "Crear nuevo dispositivo": "Neues Ger\u00e4t erstellen", 
 "Bienvenido a kicore ¡la plataforma de gesti\u00f3n de Kiconex!": "Willkommen bei kicore, der Verwaltungsplattform von Kiconex!", 
 "Ver en kiconex": "In kiconex ansehen", 
 "ICC err\u00f3neo": "Falsches ICC", 
 "Nombre instalaci\u00f3n": "Ger\u00e4tename", 
 "Nº serie": "Seriennummer", 
 "Versi\u00f3n hardware": "Hardware Version", 
 "Ninguno": "Keiner", 
 "Chino": "C", 
 "Plan kiconex": "Kiconex planen", 
 "Basic": "Basic", 
 "Professional": "Proffesional", 
 "Premium": "Premium", 
 "No": "Nein", 
 "S\u00ed": "Ja", 
 "Cable": "Kabel", 
 "Fabricado": "Hergestellt", 
 "Asignado": "Zugewiesen", 
 "Terminado": "Fertig", 
 "Eliminado": "Gel\u00f6scht", 
 "Volver": "Zur\u00fcckkehren", 
 "¡MAC err\u00f3nea!": "Falscher MAC!", 
 "Introduzca una MAC o IMEI v\u00e1lidos": "Geben Sie eine g\u00fcltige MAC- oder IMEI-Nummer ein", 
 "Generar UUID": "UUID generieren", 
 "¡SSID err\u00f3neo!": "Falscher SSID!", 
 "¡UUID err\u00f3neo!": "Falscher UUID!", 
 "¡ICC err\u00f3neo!": "Falscher ICC!", 
 "¡N\u00famero de serie err\u00f3neo!": "Falsche Seriennummer!", 
 "Grupo comercial": "Handelsgruppe", 
 "Habilitaci\u00f3n": "Bef\u00e4higung", 
 "F\u00e1brica": "Fabrik", 
 "Administraci\u00f3n": "Verwaltung", 
 "Gesti\u00f3n": "Management", 
 "Usuarios": "Benutzer", 
 "Lista kibox": "Kibox auff\u00fchren", 
 "Lista kiwi": "Kiwi auff\u00fchren", 
 "Kibox asignados": "Zugewiesene Kiboxen", 
 "Kiwis asignados": "Zugeteilte Kiwis", 
 "No se conecta al WiFi": "Stellt keine WLAN-Verbindung her", 
 "Este pedido debe salir con una pegatina extra": "Diese Bestellung muss mit einem zus\u00e4tzlichen Aufkleber versehen sein", 
 "Cambiar estado de la SIM": "SIM-Status \u00e4ndern", 
 "Estado de la SIM": "SIM-Status", 
 "Fruter\u00eda fulanito": "Beispiel Obstladen", 
 "Token actualizado correctamente": "Token erfolgreich aktualisiert", 
 "Usuario creado correctamente": "Benutzer erfolgreich erstellt", 
 "No hay respuesta del servidor": "Es kommt keine Antwort vom Server", 
 "Error": "Fehler", 
 "Error al cerrar sesi\u00f3n": "Fehler beim Abmelden", 
 "Seleccionar idioma": "Sprache ausw\u00e4hlen", 
 "Espa\u00f1ol": "Spanisch", 
 "Ingl\u00e9s": "Englisch", 
 "Franc\u00e9s": "Franz\u00f6sisch", 
 "Alem\u00e1n": "Deutsch", 
 "UUID": "UUID", 
 "Nombre comercial": "Handelsname", 
 "Pedido comercial": "Handelsordnung", 
 "N\u00famero de serie comercial": "Kommerzielle Seriennummer", 
 "Modelo del equipo": "Ausstattungsmodell", 
 "Estado Comercial": "Kaufm\u00e4nnischer Status", 
 "Fecha Conexi\u00f3n": "Datumsverbindung", 
 "Subscripci\u00f3n": "Abonnement", 
 "Comercial": "Werbung", 
 "General": "Allgemein", 
 "Placa borrada correctamente": "Platte erfolgreich gel\u00f6scht", 
 "Sistema": "System", 
 "Privilegios": "Privilegien", 
 "Roles": "Rollen", 
 "Usuario borrado correctamente": "Benutzer erfolgreich gel\u00f6scht", 
 "Cambiar contrase\u00f1a": "Kennwort \u00e4ndern", 
 "Columnas": "S\u00e4ulen", 
 "Sin informaci\u00f3n": "Keine Information", 
 "Cerrar": "Schlie\u00dfen", 
 "Cambiar": "\u00c4ndern", 
 "Por favor, seleccione una opcion": "Bitte w\u00e4hle eine Option", 
 "¡Las contrase\u00f1as deben coincidir!": "¡Die Passw\u00f6rter m\u00fcssen \u00fcbereinstimmen!", 
 "La contrase\u00f1a es un campo obligatorio": "Passwort ist ein Pflichtfeld", 
 "success": "Erfolg", 
 "Contrase\u00f1a actualizada correctamente": "Passwort erfolgreich aktualisiert", 
 "Las contrase\u00f1as deben coincidir": "Die Passw\u00f6rter m\u00fcssen \u00fcbereinstimmen", 
 "Cambio de contrase\u00f1a usuario": "\u00c4nderung des Benutzerkennworts", 
 "Debe seleccionar un rol": "Sie m\u00fcssen eine Rolle ausw\u00e4hlen", 
 "Rol creado correctamente": "Rolle erfolgreich erstellt", 
 "Nuevo Rol": "Neue Rolle", 
 "Informaci\u00f3n de Rol": "Rolleninformationen", 
 "Rol borrado correctamente": "Rolle erfolgreich gel\u00f6scht", 
 "Rol administrador": "Administratorrolle", 
 "Sincronizar": "Synchronisieren", 
 "¡Sincronizar datos!": "¡Daten synchronisieren!", 
 "Nombre, Organizaci\u00f3n y subscripci\u00f3n van a ser modificados por el valor que tengan en la plataforma Kiconex \u00bfEst\u00e1 seguro de esto?": "Name, Organisation und Abonnement werden durch den Wert ge\u00e4ndert, den sie auf der Kiconex-Plattform haben. Sind Sie sich sicher?", 
 "Usuario guardado correctamente": "Benutzer erfolgreich gespeichert", 
 "Nuevo usuario": "Neuer Benutzer", 
 "Editando usuario": "Benutzer bearbeiten", 
 "Software": "Software", 
 "Crear": "Erstellen", 
 "Ver": "Sehen", 
 "Finalizar": "Beenden", 
 "Editar comercial": "Werbung bearbeiten", 
 "Gesti\u00f3n de placas de f\u00e1brica": "Verwaltung von Werkskennzeichen", 
 "Asignaciones de f\u00e1brica": "Fabrikzuweisungen", 
 "Asignaci\u00f3n de placas de f\u00e1brica": "Zuordnung von Fabrikschildern", 
 "Gesti\u00f3n de placas de administraci\u00f3n": "Gesch\u00e4ftsf\u00fchrung des Verwaltungsrats", 
 "mykiconex": "mykiconex", 
 "Gesti\u00f3n con plataforma mykiconex": "Verwaltung mit mykiconex-Plattform", 
 "M2M": "M2M", 
 "Ver M2M": "Siehe M2M", 
 "Ver estado": "Status anzeigen", 
 "Ver listado pools": "Siehe Poolliste", 
 "Refrescar pools": "Pools auffrischen", 
 "Actualizar token": "Aktualisierungstoken", 
 "VPN": "VPN", 
 "Chat": "Chat", 
 "Ver privilegios": "Privilegien anzeigen", 
 "Editar privilegios": "Berechtigungen bearbeiten", 
 "Gesti\u00f3n de sistema": "Systemmanagement", 
 "Gesti\u00f3n de usuarios": "Benutzerverwaltung", 
 "Ver acceso a chat": "Chat-Zugriff anzeigen", 
 "Ver acceso a soporte": "Siehe Zugang zum Support", 
 "Ver acceso a VPN": "Siehe VPN-Zugriff", 
 "Gesti\u00f3n de tarjetas M2M": "M2M-Kartenverwaltung", 
 "Autorizaci\u00f3n": "Genehmigung", 
 "Portugu\u00e9s": "Portugiesisch", 
 "Italiano": "Italienisch", 
 "Fecha primera contrataci\u00f3n": "Erster Einstellungsdatum", 
 "Fecha \u00faltima renovaci\u00f3n": "Letzte Erneuerungsdatum", 
 "Intervalo de renovaci\u00f3n (a\u00f1os)": "Erneuerungsintervall (Jahre)", 
 "Fecha primera conexi\u00f3n": "Erster Verbindungsdatum", 
 "Privilegios guardados correctamente": "Privilegien korrekt gespeichert", 
 "Rol actualizado correctamente": "Rolle korrekt aktualisiert", 
 "N\u00famero Pedido": "Bestellnummer", 
 "Asunto": "Aff\u00e4re", 
 "Asignado a": "Zugewiesen an", 
 "Fecha de Creaci\u00f3n": "Erstellungsdatum", 
 "Pendiente": "Rechtsh\u00e4ngig", 
 "Cambiar Estado": "Status \u00e4ndern", 
 "Estado del Pedido actualizado correctamente": "Bestellstatus ordnungsgem\u00e4\u00df aktualisiert", 
 "Cliente Final": "Endkunde", 
 "Referencia Presupuesto": "Budgetreferenz", 
 "Precio Total": "Gesamtpreis", 
 "Ver en CRM": "Siehe in CRM", 
 "N\u00famero Presupuesto": "Budgetnummer", 
 "En Proceso": "Im Gange", 
 "Anulado": "Abgesagt", 
 "Cambiar estado del pedido": "Bestellstatus \u00e4ndern", 
 "Pedidos": "Auftr\u00e4ge", 
 "Gesti\u00f3n de pedidos": "Bestellmanagement", 
 "Error en la operaci\u00f3n": "Betriebsfehler", 
 "UUID de placa ya en uso": "Plaque Uuid bereits verwendet", 
 "Nueva Placa Guardada": "Neue gespeicherte Platte", 
 "Placa actualizada": "Aktualisierte Platte", 
 "Placa borrada": "Gel\u00f6schte Platte", 
 "Placas actualizadas": "Aktualisierte Teller", 
 "SSID de kiwi ya en uso": "Kiwi ssid bereits verwendet", 
 "Nuevo KiWi Guardado": "Neue Kiwi gespeichert", 
 "KiWi actualizado": "Kiwi aktualisiert", 
 "KiWi borrado": "Kiwi gel\u00f6scht", 
 "Token actualizado": "Token aktualisiert", 
 "Nombre de rol ya en uso": "Rollenname bereits verwendet", 
 "Rol actualizado": "Rolle aktualisiert", 
 "No puede eliminar un rol con dependencias": "Kann keine Rolle mit Abh\u00e4ngigkeiten beseitigen", 
 "La clave ha expirado.": "Der Schl\u00fcssel ist abgelaufen.", 
 "Usuario no encontrado.": "Benutzer nicht gefunden.", 
 "Las contrase\u00f1as son obligatorias.": "Passw\u00f6rter sind obligatorisch.", 
 "Las contrase\u00f1as no coinciden.": "Passw\u00f6rter stimmen nicht \u00fcberein.", 
 "Nombre de usuario ya en uso": "Benutzername bereits vergeben", 
 "Error del servidor.": "Serverfehler.", 
 "El usuario no ha sido activado.": "Der Benutzer wurde nicht aktiviert.", 
 "Inicio de sesi\u00f3n con \u00e9xito": "Anmeldung erfolgreich", 
 "Contrase\u00f1a incorrecta": "Falsches Passwort", 
 "Fecha Renovaci\u00f3n": "Verl\u00e4ngerungsdatum", 
 "Tiempo Restante": "\u00dcbrige Zeit", 
 " meses restantes": " verbleibende Monate", 
 "Pedidos a expirar": "Bestellungen ablaufen", 
 "Descargar Informe": "Bericht herunterladen", 
 "Renovaciones": "Renovierungsarbeiten", 
 "Pr\u00f3ximo mes": "N\u00e4chsten Monat", 
 "Pr\u00f3ximos 3 meses": "N\u00e4chste 3 Monate", 
 "Pr\u00f3ximos 6 meses": "N\u00e4chste 6 Monate", 
 "Pr\u00f3ximo a\u00f1o": "N\u00e4chstes Jahr", 
 "Ver renovaciones": "Siehe Renovierungsarbeiten", 
 "Caducada": "Abgelaufen", 
 " d\u00edas restantes": " verbleibende tage", 
 "Aceptar": "Akzeptieren", 
 "Reiniciar": "Neu starten", 
 "Sin organizaci\u00f3n": "Keine Organisation", 
 "Ver pools": "Siehe Pools", 
 "Alarmas": "Alarm", 
 "Alarmas M2M": "Alarm M2M", 
 "Sin alertas": "Ohne Warnungen", 
 "Advertencia": "Warnung", 
 "Critica": "Kritik", 
 "Renovaciones expiradas": "Abgelaufene Renovierungsarbeiten", 
 "Pedidos pendientes": "Ausstehende Bestellungen", 
 "Tarjetas desactivadas desde hace mas de 12 meses": "Karten deaktiviert l\u00e4nger als 12 Monate", 
 "Ver m\u00e1s": "Mehr sehen", 
 "Creaci\u00f3n": "Schaffung", 
 "Actualizaci\u00f3n": "Aktualisieren", 
 "Borrado": "Gel\u00f6scht", 
 "Cambio de estado": "Status \u00c4nderung", 
 "Cambio de contrase\u00f1a": "\u00c4nderung des Passworts", 
 "Sincronizaci\u00f3n": "Synchronisation", 
 "Sin acci\u00f3n": "Keine Aktion", 
 "Fecha": "Datum", 
 "Acci\u00f3n": "Aktion", 
 "Tipo de objeto": "Art des Objekts", 
 "Identificador": "Kennung", 
 "Placa": "Platte", 
 "Hace 3 horas": "vor 3 Stunden", 
 "Hace 1 d\u00eda": "Vor 1 Tag", 
 "Hace 3 d\u00edas": "vor 3 Tagen", 
 "Hace 1 semana": "Vor 1 Woche", 
 "Actividad": "Aktivit\u00e4t", 
 "Listado": "Auff\u00fchren", 
 "Ver actividad": "Siehe Aktivit\u00e4t", 
 "Privilegio": "Privileg", 
 "No es posible personificar desde un personificado.": "Es ist nicht m\u00f6glich, von einem Personified zu personifizieren.", 
 "Personificaci\u00f3n": "Personifikation", 
 "Personificando al usuario": "Personifizierung des Benutzers", 
 "Volver a la sesi\u00f3n": "In die Sitzung gehen", 
 "Personificar": "Personifizieren", 
 "No es posible personificarse a si mismo.": "Es ist nicht m\u00f6glich, sich selbst zu personifizieren.", 
 "Comienzo Personificaci\u00f3n": "Personifikation starten", 
 "Fin Personificaci\u00f3n": "Endpersonifikation", 
 "Ajustes": "Einstellungen", 
 "Actualizar listado": "Aktualisierungsliste", 
 "Refrescar pedidos": "Bestellungen aktualisieren", 
 "Refrescar ordenes de trabajo": "Bestellungen Arbeitsauftrag", 
 "de": "von", 
 "filtrados de": "gefiltert von", 
 "Actualizar listado de organizaciones": "Aktualisieren Sie die Liste der Organisationen", 
 "Actualizar nombre, plan y organizaci\u00f3n de kibox": "Aktualisieren Sie den Namen, Plan und die Organisation von Kibox", 
 "Actualizar listado de pedidos": "Aktualisieren Sie die Auftr\u00e4ge", 
 "Actualizar listado de ordenes de trabajo": "Aktualisieren Sie die Arbeitsauftrag", 
 "Actualizaci\u00f3n de listados": "Listen -Update", 
 "Actualizado con exito": "Mit Erfolg aktualisiert", 
 "Activa": "Aktiv", 
 "Sin intervalo": "Kein Intervall", 
 "Mostrar todo": "Zeigen Sie alles", 
 "Estado de suscripci\u00f3n no compatible con el intervalo seleccionado": "Abonnementstatus nicht mit dem ausgew\u00e4hlten Intervall kompatibel", 
 "Estado del plan": "Planstatus", 
 "Caducado": "Zeitlich abgestimmt", 
 "Inactivo": "Leerlauf", 
 "Cancelado": "Abgesagt", 
 "No procede": "Es geht nicht fort", 
 "¡Orden de trabajo erronea!": "Irrt\u00fcmlich Arbeitsauftrag!", 
 "Rellene el formulario correctamente": "F\u00fcllen Sie das Formular richtig aus", 
 "Orden de trabajo": "Arbeitsauftrag", 
 "Su sesi\u00f3n va a ser cerrada": "Ihre Sitzung wird geschlossen", 
 "Su sesi\u00f3n se cerrar\u00e1 para aplicar los cambios": "Sie werden abgemeldet, um die \u00c4nderungen zu \u00fcbernehmen", 
 "Inicie sesi\u00f3n de nuevo": "Melden Sie sich erneut an", 
 "Posee una versi\u00f3n no compatible": "Es hat eine nicht kompatible Version", 
 "Consumo": "Verbrauch", 
 "Consumo de la SIM": "SIM-Verbrauch", 
 "Mensual": "Monatlich", 
 "Diario": "Tagebuch", 
 "UUID ya en uso": "UUID wird bereits verwendet", 
 "VPN creada correctamente": "VPN erfolgreich erstellt", 
 "VPN actualizada correctamente": "VPN erfolgreich aktualisiert", 
 "Contrase\u00f1a copiada al portapapeles": "Passwort in die Zwischenablage kopiert", 
 "Fallo al copiar la contrase\u00f1a": "Das Passwort konnte nicht kopiert werden", 
 "Nueva conexi\u00f3n VPN": "Neue VPN-Verbindung", 
 "Regenerar contrase\u00f1a": "Passwort neu generieren", 
 "Contrase\u00f1a VPN": "VPN-Passwort", 
 "Copie la contrase\u00f1a antes de guardar, no volver\u00e1 a ser visible": "Kopieren Sie das Passwort vor dem Speichern, es ist dann nicht mehr sichtbar", 
 "VPN (antigua)": "VPN (alt)", 
 "Ver acceso a VPN (antigua)": "VPN-Zugang anzeigen (alt)", 
 "Ver VPN (antigua)": "VPN anzeigen (alt)", 
 "Ver VPN": "VPN anzeigen", 
 "Crear VPN": "VPN erstellen", 
 "Editar VPN": "VPN bearbeiten", 
 "Ver informaci\u00f3n": "Siehe Informationen", 
 "Informaci\u00f3n placas": "Platteninformationen", 
 "Modelo de hardware": "Hardwaremodell", 
 "Fecha de compilaci\u00f3n": "Baudatum", 
 "Versi\u00f3n de Daemon": "Daemon-Version", 
 "Fecha de actualizaci\u00f3n": "Aktualisierungsdatum", 
 "Actualizado": "Aktualisiert", 
 "No actualizado": "Nicht aktualisiert", 
 "Descargar fichero de configuraci\u00f3n": "Konfigurationsdatei herunterladen", 
 "Nunca": "Niemals", 
 "Dispositivo": "Ger\u00e4t", 
 "Router kiconex": "Kiconex-Router", 
 "Fecha de expedici\u00f3n": "Ausgabedatum", 
 "\u00bfEst\u00e1 seguro de que desea eliminar este elemento?": "Sind Sie sicher, dass Sie dieses Element l\u00f6schen m\u00f6chten?", 
 "Confirmaci\u00f3n de eliminaci\u00f3n": "L\u00f6schbest\u00e4tigung", 
 "S\u00ed, eliminar": "Ja, l\u00f6schen", 
 "Cancelar": "Stornieren", 
 "Unidades de cable": "Kabeleinheiten", 
 "En espera": "Ausstehend", 
 "En proceso": "Im Prozess", 
 "UUID Original": "UUID Original", 
 "El nombre es obligatorio": "Der Name ist obligatorisch", 
 "UUID no v\u00e1lido": "Ung\u00fcltige UUID", 
 "API Key borrada": "API-Schl\u00fcssel gel\u00f6scht", 
 "La fecha de expiraci\u00f3n debe ser posterior a la fecha actual": "Das Verfallsdatum muss nach dem aktuellen Datum liegen", 
 "Clave editada correctamente": "Schl\u00fcssel korrekt bearbeitet", 
 "Clave creada correctamente": "Schl\u00fcssel erfolgreich erstellt", 
 "Clave copiada al portapapeles": "Schl\u00fcssel in die Zwischenablage kopiert", 
 "\u00bfEst\u00e1s seguro?": "Sind Sie sicher?", 
 "No podr\u00e1s volver a ver esta clave API. \u00bfDeseas continuar?": "Sie werden diesen API-Schl\u00fcssel nicht mehr sehen k\u00f6nnen. M\u00f6chten Sie fortfahren?", 
 "S\u00ed, cerrar": "Ja, schlie\u00dfen", 
 "La clave no volver\u00e1 a estar disponible": "Der Schl\u00fcssel wird nicht mehr verf\u00fcgbar sein", 
 "\u00bfDeseas borrar esta clave API?": "M\u00f6chten Sie diesen API-Schl\u00fcssel l\u00f6schen?", 
 "S\u00ed, borrar": "Ja, l\u00f6schen", 
 "Clave borrada correctamente": "Schl\u00fcssel erfolgreich gel\u00f6scht", 
 "Sin descripci\u00f3n": "Keine Beschreibung", 
 "Fecha de expiraci\u00f3n": "Verfallsdatum", 
 "Editar clave API": "API-Schl\u00fcssel bearbeiten", 
 "Nueva clave API": "Neuer API-Schl\u00fcssel", 
 "Copiar clave": "API-Schl\u00fcssel kopieren", 
 "Clave API creada correctamente": "API-Schl\u00fcssel erfolgreich erstellt", 
 "Esta es tu clave API. No podr\u00e1s volver a consultarla en el futuro, c\u00f3piala y \u00fasala donde necesites": "Dies ist Ihr API-Schl\u00fcssel. Sie werden ihn in Zukunft nicht mehr einsehen k\u00f6nnen. Kopieren Sie ihn und verwenden Sie ihn, wo immer Sie ihn brauchen.", 
 "Claves API": "API-Schl\u00fcssel", 
 "Listado de claves API": "Liste der API-Schl\u00fcssel", 
 "Generar nueva clave": "Neuen Schl\u00fcssel generieren", 
 "Editar claves": "Schl\u00fcssel bearbeiten", 
 "Editar tracker": "Tracker bearbeiten", 
 "Modelo control": "Control-Modell", 
 "Clave API control": "Control-API-Schl\u00fcssel", 
 "Clave API box": "Box-API-Schl\u00fcssel", 
 "Actualizar claves de acceso para: ": "Zugangsschl\u00fcssel aktualisieren f\u00fcr: ", 
 "Traductor de librer\u00edas": "Bibliotheks\u00fcbersetzer", 
 "Estado de subscripci\u00f3n": "Abonnementstatus", 
 "Versi\u00f3n": "Version", 
 "Sin versi\u00f3n": "Keine Version", 
 "Sin modelo": "Kein Modell", 
 "Primero seleccione un modelo": "W\u00e4hlen Sie zuerst ein Modell aus", 
 "Tendr\u00e1 que volver a iniciar sesi\u00f3n para usar la nueva clave": "Sie m\u00fcssen sich erneut anmelden, um den neuen Schl\u00fcssel zu verwenden", 
 "El nombre de usuario es un campo obligatorio": "Benutzername ist ein Pflichtfeld", 
 "Pedido es un campo obligatorio": "Bestellung ist ein Pflichtfeld", 
 "UUID es un campo obligatorio": "UUID ist ein erforderliches Feld", 
 "Modelo y versi\u00f3n son campos obligatorios": "Modell und Version sind erforderliche Felder", 
 "Renovaciones M2M expiradas": "Abgelaufene M2M-Erneuerungen", 
 "Renovaciones de plan expiradas": "Abgelaufene Planerneuerungen", 
 "Ingrese el n\u00famero de meses": "Geben Sie die Anzahl der Monate ein", 
 "Intervalo de renovaci\u00f3n": "Erneuerungsintervall", 
 "suscripci\u00f3n": "Abonnement", 
 "suscripciones": "Abonnements", 
 "Editando": "Bearbeiten", 
 "Renovando": "Erneuerung", 
 "suscripciones actualizadas correctamente": "Abonnements erfolgreich aktualisiert", 
 "Pr\u00f3xima renovaci\u00f3n": "N\u00e4chste Erneuerung", 
 "Renovar": "Erneuern", 
 "\u00bfD\u00f3nde encuentro mi clave?": "Wo finde ich meinen Schl\u00fcssel?", 
 "Clave API Cloud": "Cloud-API-Schl\u00fcssel", 
 "Clave API Cloud actualizada correctamente": "Cloud-API-Schl\u00fcssel erfolgreich aktualisiert", 
 "VPN Antigua": "Altes VPN", 
 "Meses a renovar": "Monate der Erneuerung", 
 "Debe seleccionar un estado de suscripci\u00f3n": "Sie m\u00fcssen einen Abonnementstatus ausw\u00e4hlen", 
 "Plan es obligatorio": "Plan ist erforderlich", 
 "Debe seleccionar un estado de suscripci\u00f3n M2M": "Sie m\u00fcssen einen M2M-Abonnementstatus ausw\u00e4hlen", 
 "ICC es obligatorio": "ICC ist erforderlich", 
 "Hist\u00f3rico de suscripci\u00f3n": "Abonnementverlauf", 
 "Fecha de primera conexi\u00f3n": "Datum der ersten Verbindung", 
 "Fecha de renovaci\u00f3n": "Erneuerungsdatum", 
 "meses": "Monate", 
 "Realizado por": "Durchgef\u00fchrt von", 
 "Eliminaci\u00f3n": "L\u00f6schung", 
 "Cancelaci\u00f3n": "Stornierung", 
 "Preparaci\u00f3n": "Vorbereitung", 
 "Cambio de intervalo": "Intervalland\u00e4nderung", 
 "Cambio de plan": "Planand\u00e4nderung", 
 "Caducadas": "Abgelaufen", 
 "Por vencer": "Ausstehend", 
 "Cargando": "Laden", 
 "Gestionar perfil": "Profil verwalten", 
 "Instalaci\u00f3n original": "Originalinstallation", 
 "Actualizar en Kite": "In Kite aktualisieren", 
 "Debe seleccionar una suscripci\u00f3n de plan": "Sie m\u00fcssen ein Planabonnement ausw\u00e4hlen", 
 "Propietario": "Eigent\u00fcmer", 
 "Tarifa": "Tarif", 
 "Nueva fecha": "Neues Datum", 
 "Error al crear usuario": "Fehler beim Erstellen des Benutzers", 
 "Error al obtener datos": "Fehler beim Abrufen der Daten", 
 "Error al cargar las claves API": "Fehler beim Laden der API-Schl\u00fcssel", 
 "Error al guardar la clave": "Fehler beim Speichern des Schl\u00fcssels", 
 "Error al borrar la clave": "Fehler beim L\u00f6schen des Schl\u00fcssels", 
 "Error al editar la clave": "Fehler beim Bearbeiten des Schl\u00fcssels", 
 "Error al copiar la clave": "Fehler beim Kopieren des Schl\u00fcssels", 
 "No puedes cambiar la fecha de expiraci\u00f3n una vez creada": "Sie k\u00f6nnen das Verfallsdatum nach der Erstellung nicht \u00e4ndern", 
 "No se puede devolver a Stock: la placa tiene repuestos asignados": "Kann nicht zu Stock zur\u00fcckgegeben werden: die Platine hat zugewiesene Ersatzteile", 
 "Introduzca su correo electr\u00f3nico": "Geben Sie Ihre E-Mail-Adresse ein", 
 "Si el correo existe, recibir\u00e1 un mensaje con instrucciones para restablecer su contrase\u00f1a.": "Wenn die E-Mail-Adresse vorhanden ist, erhalten Sie eine Nachricht mit Anweisungen zum Zur\u00fccksetzen Ihres Passworts.", 
 "Enviar enlace de recuperaci\u00f3n": "Wiederherstellungslink senden", 
 "Volver al inicio de sesi\u00f3n": "Zur\u00fcck zur Anmeldung", 
 "Nueva contrase\u00f1a": "Neues Passwort", 
 "Restablecer contrase\u00f1a": "Passwort zur\u00fccksetzen", 
 "El enlace de recuperaci\u00f3n ha caducado o ya ha sido utilizado. Solicite uno nuevo.": "Der Wiederherstellungslink ist abgelaufen oder wurde bereits verwendet. Bitte fordern Sie einen neuen an.", 
 "Error al restablecer la contrase\u00f1a": "Fehler beim Zur\u00fccksetzen des Passworts", 
 "\u00bfOlvid\u00f3 su contrase\u00f1a?": "Passwort vergessen?", 
 "Su contrase\u00f1a ha caducado": "Ihr Passwort ist abgelaufen", 
 "Han pasado m\u00e1s de 6 meses desde el \u00faltimo cambio. Por motivos de seguridad debe establecer una nueva contrase\u00f1a antes de continuar.": "Seit der letzten \u00c4nderung sind mehr als 6 Monate vergangen. Aus Sicherheitsgr\u00fcnden m\u00fcssen Sie vor dem Fortfahren ein neues Passwort festlegen.", 
 "Entendido": "Verstanden", 
 "La contrase\u00f1a debe tener al menos 12 caracteres.": "Das Passwort muss mindestens 12 Zeichen lang sein.", 
 "La contrase\u00f1a debe incluir al menos tres de las siguientes categor\u00edas: may\u00fasculas, min\u00fasculas, n\u00fameros y caracteres especiales.": "Das Passwort muss mindestens drei der folgenden Kategorien enthalten: Gro\u00dfbuchstaben, Kleinbuchstaben, Zahlen und Sonderzeichen.", 
 "Cambiar ahora": "Jetzt \u00e4ndern", 
 "Su contrase\u00f1a caducar\u00e1 pronto": "Ihr Passwort l\u00e4uft bald ab", 
 "Le quedan {days} d\u00edas para cambiar su contrase\u00f1a. Pulse el bot\u00f3n para hacerlo ahora.": "Sie haben noch {days} Tag(e), um Ihr Passwort zu \u00e4ndern. Klicken Sie auf die Schaltfl\u00e4che, um es jetzt zu tun.", 
 "copiado al portapapeles": "kopiert in die Zwischenablage",
 "C\u00f3digos copiados al portapapeles": "Wiederherstellungscodes in die Zwischenablage kopiert",
 "C\u00f3digos de recuperaci\u00f3n": "Wiederherstellungscodes",
 "Gu\u00e1rdelos en un lugar seguro. No se volver\u00e1n a mostrar. Cada uno sirve una sola vez si pierde el acceso a su aplicaci\u00f3n.": "Bewahren Sie sie an einem sicheren Ort auf. Sie werden nicht mehr angezeigt. Jeder kann verwendet werden, wenn Sie Zugriff auf Ihre App verlieren.",
 "Copiar c\u00f3digos": "Codes kopieren",
 "Introduzca el c\u00f3digo": "Code eingeben",
 "C\u00f3digo incorrecto": "Falscher Code",
 "Verificaci\u00f3n en dos pasos desactivada": "Zwei-Faktor-Verifizierung deaktiviert",
 "Verificaci\u00f3n en dos pasos": "Zwei-Faktor-Verifizierung",
 "Introduzca uno de sus c\u00f3digos de recuperaci\u00f3n para desactivar la verificaci\u00f3n en dos pasos.": "Geben Sie einen Ihrer Wiederherstellungscodes ein, um die Zwei-Faktor-Verifizierung zu deaktivieren.",
 "C\u00f3digo de recuperaci\u00f3n": "Wiederherstellungscode",
 "Desactivar 2FA": "2FA deaktivieren",
 "Usar el c\u00f3digo de la aplicaci\u00f3n": "App-Code verwenden",
 "\u00bfNo tiene acceso a la app? Usar un c\u00f3digo de recuperaci\u00f3n": "Kein Zugriff auf die App? Wiederherstellungscode verwenden",
 "Su cuenta est\u00e1 protegida con un segundo factor. Para desactivarlo, introduzca un c\u00f3digo de su aplicaci\u00f3n de autenticaci\u00f3n.": "Ihr Konto ist mit einem zweiten Faktor geschützt. Um es zu deaktivieren, geben Sie einen Code von Ihrer Authentifizierungs-App ein.",
 "\u00d1ade una capa extra de seguridad. Necesitar\u00e1 una app como Google Authenticator para generar los c\u00f3digos.": "Fügen Sie eine zusätzliche Sicherheitsebene hinzu. Sie benötigen eine App wie Google Authenticator, um die Codes zu generieren.",
 "1. Escanee el c\u00f3digo QR con su aplicaci\u00f3n de autenticaci\u00f3n": "1. Scannen Sie den QR-Code mit Ihrer Authentifizierungs-App",
 "\u00bfNo puede escanear? Introduzca esta clave manualmente": "Kann nicht scannen? Geben Sie diesen Schlüssel manuell ein",
 "2. Introduzca el c\u00f3digo de 6 d\u00edgitos que muestra la app": "2. Geben Sie den 6-stelligen Code ein, der von der App angezeigt wird",
 "Su contrase\u00f1a ha caducado": "Ihr Passwort ist abgelaufen",
 "Error al obtener datos": "Fehler beim Abrufen der Daten",
 "Error al copiar": "Kopieren fehlgeschlagen",
 "Tarifa es obligatorio": "Tarif ist obligatorisch",
 "M2M actualizado correctamente": "M2M erfolgreich aktualisiert",
 "Error al actualizar M2M": "Fehler beim Aktualisieren von M2M",
 "Enlace no válido o expirado. Pídalo de nuevo o póngase en contacto con un administrador.": "Ungültiger oder abgelaufener Link. Fordern Sie ihn erneut an oder wenden Sie sich an einen Administrator.",
 "Datos personales": "Pers\u00f6nliche Daten",
 "Seguridad y acceso": "Sicherheit und Zugriff",
 "Zona horaria": "Zeitzone",
 "Seleccione una zona horaria": "Zeitzone ausw\u00e4hlen",
 "Sin instalaci\u00f3n": "Kein Ger\u00e4t",
 "Cambiar clave API Cloud": "Cloud-API-Schl\u00fcssel \u00e4ndern",
 "Librerías": "Bibliotheken",
 "Plantillas": "Vorlagen",
 "No tiene configurada una clave API Cloud": "Sie haben keinen Cloud-API-Schlüssel konfiguriert",
 "El traductor de librerías necesita su clave API Cloud para acceder a las librerías.": "Der Bibliotheksübersetzer benötigt Ihren Cloud-API-Schlüssel, um auf die Bibliotheken zuzugreifen.",
 "Configurar clave": "Schlüssel konfigurieren",
 "UUID copiado al portapapeles": "UUID in die Zwischenablage kopiert",
 "Error al copiar el UUID": "Fehler beim Kopieren der UUID",
 "Idioma por defecto": "Standardsprache",
 "Traducir": "Übersetzen",
 "Copiar UUID": "UUID kopieren",
 "Traducir con IA": "Mit KI übersetzen",
 "Elija un contexto para poder traducir": "Wählen Sie einen Kontext, um übersetzen zu können",
 "Parámetro": "Parameter",
 "origen": "Quelle",
 "librería": "Bibliothek",
 "plantilla": "Vorlage",
 "Contexto de traducción": "Übersetzungskontext",
 "con error": "mit Fehler",
 "cancelando…": "wird abgebrochen…",
 "pausando…": "wird pausiert…",
 "en pausa": "pausiert",
 "Guardar y cerrar": "Speichern und schließen",
 "Traducir todo": "Alles übersetzen",
 "Traducir seleccionadas": "Ausgewählte übersetzen",
 "Pausar": "Pausieren",
 "Continuar": "Fortsetzen",
 "El texto en el idioma origen está vacío": "Der Text in der Ausgangssprache ist leer",
 "No se ha podido traducir": "Übersetzung nicht möglich",
 "Falta configurar la URL del WebSocket del traductor": "Die WebSocket-URL des Übersetzers ist nicht konfiguriert",
 "No hay traducciones pendientes": "Es sind keine Übersetzungen ausstehend",
 "No quedan traducciones pendientes": "Es sind keine ausstehenden Übersetzungen mehr vorhanden",
 "Traducción en pausa": "Übersetzung pausiert",
 "Traducción cancelada": "Übersetzung abgebrochen",
 "Traducción terminada": "Übersetzung abgeschlossen",
 "Error en el proceso de traducción": "Fehler im Übersetzungsvorgang",
 "Corrija las traducciones no válidas antes de guardar": "Korrigieren Sie die ungültigen Übersetzungen vor dem Speichern",
 "Traducciones guardadas": "Übersetzungen gespeichert",
 "No se han podido guardar las traducciones": "Die Übersetzungen konnten nicht gespeichert werden",
 "No se han podido cargar los parámetros de la librería": "Die Parameter der Bibliothek konnten nicht geladen werden",
 "La traducción no puede superar los {max} caracteres": "Die Übersetzung darf {max} Zeichen nicht überschreiten",
 "La traducción contiene caracteres no válidos": "Die Übersetzung enthält ungültige Zeichen",
 "La traducción por defecto no puede estar vacía": "Die Standardübersetzung darf nicht leer sein",
 "Clave API Cloud no válida": "Ungültiger Cloud-API-Schlüssel",
 "Revise su clave API Cloud para poder usar el traductor de librerías.": "Überprüfen Sie Ihren Cloud-API-Schlüssel, um den Bibliotheksübersetzer verwenden zu können.",
 "Revisar clave": "Schlüssel überprüfen",
 "cambios sin guardar": "nicht gespeicherte Änderungen",
 "Acceso al traductor de librerías": "Zugriff auf den Bibliotheksübersetzer",
 "sólo no válidas": "nur ungültige",
 "No tiene permiso para modificar esta librería": "Sie haben keine Berechtigung, diese Bibliothek zu ändern",
 "Asignar router": "Router zuweisen",
 "Contraseña del dispositivo": "Gerätepasswort",
 "Crear box": "Box erstellen",
 "Crear router": "Router erstellen",
 "Duplicado": "Duplikat",
 "El modem ya no está disponible": "Das Modem ist nicht mehr verfügbar",
 "Este dispositivo no tiene ningún modem Teltonika asociado": "Diesem Gerät ist kein Teltonika-Modem zugeordnet",
 "Este dispositivo no tiene ningún router kiconex asignado": "Diesem Gerät ist kein Kiconex-Router zugewiesen",
 "Exportar a Excel": "Nach Excel exportieren",
 "Falta el número de serie": "Seriennummer fehlt",
 "Falta la MAC": "MAC fehlt",
 "Falta la contraseña": "Passwort fehlt",
 "Fecha alta": "Erstellungsdatum",
 "Fichero": "Datei",
 "Fila": "Zeile",
 "IMEI no válido": "Ungültige IMEI",
 "Importar": "Importieren",
 "Importar modems": "Modems importieren",
 "Información de modem": "Modem-Informationen",
 "Información de router": "Router-Informationen",
 "Libres": "Frei",
 "MAC no válida": "Ungültige MAC",
 "Modem": "Modem",
 "Modem Teltonika": "Teltonika-Modem",
 "Modem borrado correctamente": "Modem erfolgreich gelöscht",
 "Modem es un campo obligatorio": "Modem ist ein Pflichtfeld",
 "Modems importados": "Modems importiert",
 "No se ha podido cargar la información del router": "Router-Informationen konnten nicht geladen werden",
 "No se ha podido leer el fichero": "Die Datei konnte nicht gelesen werden",
 "Nuevo modem": "Neues Modem",
 "Nuevo repuesto": "Neues Ersatzteil",
 "Nuevo router": "Neuer Router",
 "Observaciones": "Anmerkungen",
 "Organización es un campo obligatorio": "Organisation ist ein Pflichtfeld",
 "Repetido en el fichero": "In der Datei wiederholt",
 "Revisa los campos marcados": "Überprüfen Sie die markierten Felder",
 "Router": "Router",
 "Router (dato antiguo)": "Router (alte Daten)",
 "Router borrado correctamente": "Router erfolgreich gelöscht",
 "Router no disponible": "Router nicht verfügbar",
 "Router terminado": "Router fertig",
 "Seleccionar fichero": "Datei auswählen",
 "Seleccionar router": "Router auswählen",
 "Sin modem Teltonika": "Kein Teltonika-Modem",
 "Sin tipo": "Kein Typ",
 "Stock Kiconex": "Kiconex-Bestand",
 "Stock Teltonika": "Teltonika-Bestand",
 "Tipo": "Typ",
 "Tipo Teltonika": "Teltonika-Typ",
 "Tracker": "Tracker",
 "Transformados": "Umgewandelt",
 "UUID router": "Router-UUID",
 "Versión placa": "Platinenversion",
 "Válido": "Gültig",
 "Ya existe en el sistema": "Bereits im System vorhanden",
 "duplicadas": "Duplikate",
 "filas leídas": "gelesene Zeilen",
 "válidas": "gültig",
 "¡IMEI erróneo!": "Falsche IMEI!",
 "Lista routers": "Router aufführen",
 "Routers asignados": "Zugewiesene Router",
 "Seleccionar ICC": "ICC auswählen",
  "Se deben renovar al menos": "Mindestens",
},
  "plural": "(n != 1)"
  };
